import React, { useState } from 'react';
import Error from './Error';

const Form = ({searchItem}) => {

    const [item, setItem] = useState('');
    const [error, setError] = useState(false);

    const updateItem = e => {
        e.preventDefault();
        //validamos
        if (item === '') {
            setError(true);
            return;
        }
        setError(false);
        //pasamos los datos al comonente
        searchItem(item);
    }

    return (
        <form
        onSubmit={updateItem}
        >
        <div className="row">
          <div className="form-group col-md-8">
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Busca una Imagen ej: Futobol o cafe"
              onChange={(e) => setItem(e.target.value)}
            />
          </div>
          <div className="form-group col-md-4">
            <input
              type="submit"
              className="btn btn-lg btn-danger btn-block"
              value="Buscar"
            />
          </div>
            </div>
            {error ? <Error message='No hay Imagenes para buscar' /> : null}
      </form>
    );
}
 
export default Form;